import { IconButton } from 'app/agriculture/components/Button/Button';
import './ZoomButtons.scss';
import { use } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { MinusIcon, PlusIcon } from 'app/agriculture/icons';
import { primaryColourText } from 'app/agriculture/material';
import classNames from 'classnames';

interface ZoomButtonsProps {
    viewer?: Cesium.Viewer | null;
    className?: string;
}

export function ZoomButtons(props: ZoomButtonsProps) {
    const { mapService } = use(ServicesContext);
    const { viewer = mapService.viewer, className } = props;
    if (viewer == null) return null;

    const handleZoomInClick = () => {
        const { height } = viewer.scene.camera.positionCartographic;
        if (height <= 1) return;
        viewer.camera.zoomIn(height / 3);
    };

    const handleZoomOutClick = () => {
        const { height } = viewer.scene.camera.positionCartographic;
        if (height <= 1) return;
        viewer.camera.zoomOut(height / 2);
    };

    return (
        <div className={classNames('ZoomButtons', className)}>
            <IconButton
                className="ZoomButtons__button ZoomButtons__minus"
                tooltip="Zoom out"
                icon={<MinusIcon color={primaryColourText} />}
                variant="textonly"
                onClick={handleZoomOutClick}
            />
            <IconButton
                className="ZoomButtons__button ZoomButtons__plus"
                tooltip="Zoom in"
                icon={<PlusIcon color={primaryColourText} />}
                variant="textonly"
                onClick={handleZoomInClick}
            />
        </div>
    );
}
